import React, { MouseEventHandler } from 'react';
import { BreakPoints, LinkWithAnalytics, LinkWithAnalyticsProps } from '@soluto-home-web/platform-common-ui';
import Color from 'color';
import styled from 'styled-components';

type OutterProps = {
  to: string;
  actionId: string;
  target?: string;
  className?: string;
  onClick?: MouseEventHandler<any>;
};

export type LinkProps = Partial<LinkWithAnalyticsProps & OutterProps>;

const StyledLink = styled(LinkWithAnalytics)`
  padding: 0.75em 0;
  -webkit-tap-highlight-color: transparent;
  margin-left: 0.4em;
  margin-right: 0.4em;
  font-size: 0.8rem;
  color: #454545;
  text-decoration: none;

  :active {
    background-color: ${(props) => Color(props.theme.colors.input_highlight).alpha(0.2).string()};
  }

  @media ${BreakPoints.desktop} {
    line-height: 1.5rem;
    padding: 1.8em 0.5em;

    :hover {
      text-decoration: underline;
    }

    :active {
      background-color: transparent;
    }
  }
`;

const commonExtraData = { SourceUrl: location.toString() };

export const Link: React.FC<LinkProps> = ({ children, to, target, actionId, className, onClick }) => (
  <StyledLink
    className={className}
    to={to || '#'}
    analyticsExtras={{ ActionId: actionId, DestinationUrl: to, ...commonExtraData }}
    target={target}
    onClick={onClick}
  >
    {children}
  </StyledLink>
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/links/Link.tsx